import Login from 'src/pages/Auth/Login.vue'
import ForgotPassword from 'src/pages/Auth/ForgotPassword.vue'
import ResetPassword from 'src/pages/Auth/ResetPassword.vue'
import UserInvite from 'src/pages/Auth/UserInvite.vue'

const guest = { requiresGuest: true }

export default [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: guest
  },
  {
    path: '/password/forgot',
    name: 'Forgot Password',
    component: ForgotPassword,
    meta: guest
  },
  {
    path: '/password/reset/:token',
    name: 'Reset Password',
    component: ResetPassword,
    meta: guest
  },
  {
    path: '/user/invite/:token',
    name: 'Account aktivieren',
    component: UserInvite,
    meta: guest
  }
]
